module.exports = __webpack_public_path__ + "img/95.35bf499a.png";